(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.mpSlider = {
    attach: function (context, settings) {
      if (typeof settings.mp_paragraphs === 'undefined') return;
      for (var id in settings.mp_paragraphs.mp_slider) {
        var slider_settings = settings.mp_paragraphs.mp_slider[id],
          $slider = $('#' + id, context)
        ;

        if ($slider.length === 0) break;

        if (slider_settings.enable_arrows) {
          $slider.addClass('slick-arrowed');
        }

        $(once('slick', $slider, context)).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: slider_settings.enable_dots,
          arrows: slider_settings.enable_arrows
        });

      }
    }
  };

})(jQuery, Drupal, drupalSettings);
